export default __webpack_public_path__ + "static/media/add-money.4b23a2bb.png";